import { useSelector } from "react-redux";
import { getDomainConfig } from "../../app/appSelectors";
import {
    MobileSliderPagesContentStyled
} from "../../mobileAppCore/components/MobileSliderPages/components/styled/MobileSliderPagesStyled";

function ClientAgreement() {
    const domainConfig = useSelector(getDomainConfig);

    return <>
        {
            domainConfig.clientAgreementHtml
                ?
                <MobileSliderPagesContentStyled dangerouslySetInnerHTML={{ __html: domainConfig.clientAgreementHtml }}/>
                : <>
                    <iframe src={domainConfig.clientAgreementLink}
                            width="100%"
                            title={'client-agreement'}
                            className={'flex-1'}/>
                </>
        }
    </>
}

export default ClientAgreement;
